import React from 'react'
import * as S from './style'

const CardLoader = () => {
  return (
    <S.StyleAnalyticCard>
      <S.TitleContainer>
        <S.ShimmerBox width={30} height={30} circle />
        <S.StyleAnalyticCardTitle>
          <S.ShimmerBox width={80} height={14} />
        </S.StyleAnalyticCardTitle>
      </S.TitleContainer>
      <S.StatsContainer>
        <S.ShimmerBox width={40} height={20} />
        <S.StartPercentContainer>
          <S.ShimmerBox width={60} height={18} />
        </S.StartPercentContainer>
      </S.StatsContainer>
      <S.ActionContainer>
        <S.ShimmerBox width={120} height={14} />
        <S.ShimmerBox width={70} height={28} />
      </S.ActionContainer>
    </S.StyleAnalyticCard>
  )
}

export default CardLoader
